import { ReactComponent as ProductFish } from "./product-fish.svg";
import { ReactComponent as ProductElectronics } from "./product-electronics.svg";
import { ReactComponent as ProductGarments } from "./product-garment.svg";
import { ReactComponent as ProductSugarcane } from "./product-sugarcane.svg";
import { ReactComponent as ProductCocoa } from "./product-cocoa.svg";

const ProductIcons = {
  Fish: ProductFish,
  Electronics: ProductElectronics,
  Garments: ProductGarments,
  Sugarcane: ProductSugarcane,
  Cocoa: ProductCocoa
}

export default ProductIcons;
